module.exports = __webpack_public_path__ + "img/product-placeholder-29.a66d7a6.png";